// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

// Import firebase
import { propertiesModel, residentsModel, unitsModel } from '@/firebase/firebase-config'
import { residentsUsersModel } from '@/firebase/residents-firebase-config'

// Import moment
import moment from 'moment'

export const DeleteLease = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        delete_lease_error: false,
        delete_lease_complete: false,
        delete_lease_processing: false,
        delete_lease_update_property_resident_complete: false,
        delete_lease_update_resident_complete: false,
        delete_lease_update_resident_portal_complete: false,
        delete_lease_update_unit_complete: false,
        delete_lease_rent_terms_deleted_complete: false,
        delete_lease_invoices_deleted_complete: false,
        delete_lease_invoice_events_deleted_complete: false,
        delete_lease_rent_terms: [],
        delete_lease_invoices: []

    }),

    /*
    **  Watch em'
    */

    watch: {

        deleted_lease_error: {

            immediate: true, // Load on created
            handler(deleted_lease_error) {

                /*
                **  Delete the lease
                **  @method: @here
                */

                if (deleted_lease_error) this.handleDeleteLeaseError();

            }

        },

        delete_lease_complete: {

            immediate: true, // Load on created
            handler(delete_lease_complete) {

                if (!this.delete_lease_error && delete_lease_complete && this.lease.attributes.status == 'active') {

                    /*
                    **  If active, update the property resident
                    **  @method: @here
                    */

                    this.deleteLeaseUpdatePropertyResident();

                } else {

                    /*
                    **  Skip to the end
                    **  @method: @here
                    */

                    if (!this.delete_lease_error && this.delete_lease_processing) this.getAndDeleteRentTerms();

                }

            }

        },

        delete_lease_update_property_resident_complete: {

            immediate: true, // Load on created
            handler(delete_lease_update_property_resident_complete) {

                /*
                **  If active, update the resident
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_update_property_resident_complete && this.lease.attributes.status == 'active') this.deleteLeaseUpdateResident();

            }

        },

        delete_lease_update_resident_complete: {

            immediate: true, // Load on created
            handler(delete_lease_update_resident_complete) {

                /*
                **  If active, update the unit
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_update_resident_complete && this.lease.attributes.status == 'active') this.deleteLeaseUpdateUnit();

            }

        },

        delete_lease_update_unit_complete: {

            immediate: true, // Load on created
            handler(delete_lease_update_unit_complete) {

                /*
                **  If active and enrolled, get the resident portal user
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_update_unit_complete && this.lease.attributes.status == 'active' && this.residents_user) this.deleteLeaseUpdatePortalUser();

            }

        },

        delete_lease_update_resident_portal_complete: {

            immediate: true, // Load on created
            handler(delete_lease_update_resident_portal_complete) {

                /*
                **  If active and enrolled, get the resident portal user
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_update_resident_portal_complete) this.deleteLeaseGetAndDeleteRentTerms();

            }

        },

        delete_lease_rent_terms_deleted_complete: {

            immediate: true, // Load on created
            handler(delete_lease_rent_terms_deleted_complete) {

                /*
                **  Get and delete the invoices
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_rent_terms_deleted_complete) this.deleteLeaseGetAndDeleteInvoices();

            }

        },

        delete_lease_invoices_deleted_complete: {

            immediate: true, // Load on created
            handler(delete_lease_invoices_deleted_complete) {

                /*
                **  Get and delete the invoices
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_invoices_deleted_complete) this.deleteLeaseGetAndDeleteInvoiceEvents();

            }

        },

        delete_lease_invoice_events_deleted_complete: {

            immediate: true, // Load on created
            handler(delete_lease_invoice_events_deleted_complete) {

                /*
                **  Get and delete the invoices
                **  @method: @here
                */

                if (!this.delete_lease_error && delete_lease_invoice_events_deleted_complete) this.completeDeleteLeaseEvent();

            }

        }

    },

    /*
	**  Methods
    */
    
    methods: {

        deleteLeaseHandler: function() {
            
            try {

                /*
                **  If double clicked
                **  @prop: @here
                */

                if (this.delete_lease_processing) return;

                /*
                **  Show the alert
                **  @service: @SweetAlert2
                */

                this.$swal({

                    title: 'Are you sure you want to delete the lease?',
                    showCancelButton: true,
                    confirmButtonText: `Delete`,
                    confirmButtonColor: '#18bbf7',
                    cancelButtonText: `Cancel`

                }).then((result) => {

                    /*
                    **  If confirmed
                    */
                    
                    if (result.isConfirmed) {

                        /*
                        **  Set the processing prop
                        **  @prop: @here
                        */

                        this.delete_lease_processing = true;

                        /*
                        **  Show the spinner
                        **  @method: Mixins/Helpers/SpinnerMethods
                        */

                        this.showSpinner();

                        /*
                        **  Delete the lease
                        **  @method: @here
                        */

                        this.deleteLeaseDocument();

                    } 

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Lease from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'kwOrFTf5TgMbwakC1n7k',
                    error: error
                });

            }

        },

        handleDeleteLeaseError: function() {

            try {

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display error message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Uh Oh!', 'We ran into a problem trying to delete the lease.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to handle the delete lease event.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'EYzSEP1TeWC1jXSpNQDx',
                    error: e
                });

            }

        },

        deleteLeaseDocument: function() {

            try {

                /*
                **  Delete the lease document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).update({
                    'meta.deleted_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_lease_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.delete_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete the Lease Document When Deleting a Lease.',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'm3ovHTZCn29jiVcxAvmI',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.delete_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Lease Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: '1Vj2KIlwi25QvKXtNNos',
                    error: error
                });

            }

        },

        deleteLeaseUpdatePropertyResident: function() {

            try {

                /*
                **  Update the property resident document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('residents').doc(this.resident.id).update({
                    'relationships.lease': null,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_lease_update_property_resident_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.delete_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete Lease - Update Property Resident Document.',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'm3ovHTZCn29jiVcxAvmI',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.delete_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Lease - Update Property Resident Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'x6RuLvO3lRdDZPqOFqRZ',
                    error: error
                });

            }

        },

        deleteLeaseUpdateResident: function() {

            try {

                /*
                **  Update the resident document
                **  @service: @Firebase/Firestore
                */

                residentsModel.doc(this.resident.id).update({
                    'relationships.lease': null,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_lease_update_resident_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.delete_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete Lease - Update Resident Document.',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: '3TcSOxLxmtwIKFLaEX77',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.delete_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Lease - Update Resident Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'x6RuLvO3lRdDZPqOFqRZ',
                    error: error
                });

            }

        },

        deleteLeaseUpdateUnit: function() {

            try {

                /*
                **  Update the unit document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('units').doc(this.resident.relationships.unit).update({
                    'relationships.lease': null,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_lease_update_unit_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.delete_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete Lease - Update Unit Document.',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'Vn6nLXTM2Z0qFm1eJ85b',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.delete_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Lease - Update Unit Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'wAFfxPXo1khqnta1Z9VV',
                    error: e
                });

            }

        },

        deleteLeaseUpdatePortalUser: function() {

            try {

                /*
                **  Update the residents portal user document
                **  @service: @Firebase/Firestore
                */

                residentsUsersModel.doc(this.residents_user.id).update({
                    'relationships.lease': null,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_lease_update_resident_portal_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.delete_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete Lease - Update Residents Portal User Document.',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'ewraDitafTNXAVDTdZa7',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.delete_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Lease - Update Residents Portal User Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: '8bzYGC5ef4ZWGNYOp3Pc',
                    error: e
                });

            }

        },

        completeDeleteLeaseEvent: function() {

            try {

                /* 
                ** Reset the props
                ** @props: @here
                */

                this.delete_lease_error = false;
                this.delete_lease_complete = false;
                this.delete_lease_processing = false;
                this.delete_lease_update_property_resident_complete = false;
                this.delete_lease_update_resident_complete = false;
                this.delete_lease_update_resident_portal_complete = false;
                this.delete_lease_update_unit_complete = false;
                this.delete_lease_rent_terms_deleted_complete = false;
                this.delete_lease_rent_terms = [];

                /* 
                ** Hide the spinner
                ** @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Navigate user to the leases page
                ** @service: @Vue
                */

                this.$router.push({ name: 'Resident', params: { id: this.$route.params.id, residentID: this.resident.id } });

                /* 
                ** Display success message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Success!', 'Your lease has been deleted.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Finish the Event for a Deleted Lease.',
                    errorType: 'Application',
                    section: 'Events/Leases',
                    uid: 'AiCsyF07lFvloCoq2ik1',
                    error: e
                });

            }

        },

        deleteLeaseGetAndDeleteRentTerms: function() {

            try {

                /*
                **  Delete the rent terms
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').get()
                .then(snapshot => {

                    /*
                    **  If empty, return
                    */

                    if (snapshot.empty) return;

                    /*
                    **  Loop through em'
                    */

                    snapshot.forEach(doc => {

                        /*
                        **  Add to the rent terms IDs list to loop through and 
                        **  get the invoices to delete later on
                        **  @prop: @here
                        */

                        this.delete_lease_rent_terms.push(doc.data().id);

                        /*
                        **  Soft delete the document
                        **  @prop: @here
                        */

                        propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(doc.data().id).update({
                            'meta.deleted_at': moment().unix()
                        })
                        .catch(error => {

                            /*
                            **  Set the error prop
                            **  @prop: @here
                            */
        
                            this.delete_lease_error = true;
        
                            /*
                            **  Send to Bugsnag
                            **  @service: Bugsnag/BugsnagService
                            */
                        
                            this.reportAuthBugsnagError({
                                title: 'Delete the Rent Term When Deleting a Lease.',
                                errorType: 'Firestore Database',
                                section: 'Events/Rent',
                                uid: '8uuK3HbixLv0ONQethzR',
                                error: error
                            });
        
                        });

                    });

                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_lease_rent_terms_deleted_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.delete_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete the Rent Term When Deleting a Lease.',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'm3ovHTZCn29jiVcxAvmI',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Get and Delete the Rent Terms for a Deleted Lease.',
                    errorType: 'Application',
                    section: 'Events/Leases',
                    uid: 'lovNxKFA9U39NYwZNavF',
                    error: e
                });

            }

        },

        deleteLeaseGetAndDeleteInvoices: function() {

            try {

                /*
                **  Delete the invoices
                **  @service: @Firebase/Firestore
                */

                if (this.delete_lease_rent_terms.length > 0) {

                    /*
                    **  Loop through the rent terms
                    */

                    this.delete_lease_rent_terms.forEach(rent_term => {

                        propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(rent_term.id).collection('invoices').get()
                        .then(snapshot => {

                            /*
                            **  If empty, return
                            */

                            if (snapshot.empty) return;

                            /*
                            **  Loop through the invoices
                            */

                            snapshot.forEach(doc => {

                                /*
                                **  Add to the invoices IDs list to loop through and 
                                **  get the invoices to delete later on
                                **  @prop: @here
                                */

                                this.delete_lease_invoices.push(doc.data().id);

                                /*
                                **  Soft delete the document
                                **  @prop: @here
                                */

                                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(rent_term.id).collection('invoices').doc(doc.data().id).update({
                                    'meta.deleted_at': moment().unix()
                                })
                                .catch(error => {

                                    /*
                                    **  Set the error prop
                                    **  @prop: @here
                                    */
                
                                    this.delete_lease_error = true;
                
                                    /*
                                    **  Send to Bugsnag
                                    **  @service: Bugsnag/BugsnagService
                                    */
                                
                                    this.reportAuthBugsnagError({
                                        title: 'Delete the Invoice When Deleting a Lease.',
                                        errorType: 'Firestore Database',
                                        section: 'Events/Rent',
                                        uid: 'FGeKGPtofSp7t08ZAplN',
                                        error: error
                                    });
                
                                });

                            });

                        })
                        .then(() => {

                            /*
                            **  Set the prop
                            **  @prop: @here
                            */

                            this.delete_lease_invoices_deleted_complete = true;

                        })
                        .catch(error => {

                            /*
                            **  Set the error prop
                            **  @prop: @here
                            */

                            this.delete_lease_error = true;

                            /*
                            **  Send to Bugsnag
                            **  @service: Bugsnag/BugsnagService
                            */
                        
                            this.reportAuthBugsnagError({
                                title: 'Delete the Invoice When Deleting a Lease.',
                                errorType: 'Firestore Database',
                                section: 'Events/Rent',
                                uid: 'QEYfjJj8J4s7pRAOlRSr',
                                error: error
                            });

                        });

                    });

                }

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Get and Delete the Invoices for a Deleted Lease.',
                    errorType: 'Application',
                    section: 'Events/Leases',
                    uid: 'qi5qiqcVKcfHGgjEyBXK',
                    error: e
                });

            }

        },

        deleteLeaseGetAndDeleteInvoiceEvents: function() {

            try {

                /*
                **  Delete the invoices
                **  @service: @Firebase/Firestore
                */

                if (this.delete_lease_invoices.length > 0) {

                    /*
                    **  Loop through the rent terms
                    */

                    this.delete_lease_invoices.forEach(invoice => {

                        propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(invoice.relationships.rent).collection('invoices').doc(invoice.id).collection('events').get()
                        .then(snapshot => {

                            /*
                            **  If empty, return
                            */

                            if (snapshot.empty) return;

                            /*
                            **  Loop through the invoices
                            */

                            snapshot.forEach(doc => {

                                /*
                                **  Soft delete the document
                                **  @prop: @here
                                */

                                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(rent_term.id).collection('invoices').doc(invoice.id).collection('events').doc(doc.data().id).update({
                                    'meta.deleted_at': moment().unix()
                                })
                                .catch(error => {

                                    /*
                                    **  Set the error prop
                                    **  @prop: @here
                                    */
                
                                    this.delete_lease_error = true;
                
                                    /*
                                    **  Send to Bugsnag
                                    **  @service: Bugsnag/BugsnagService
                                    */
                                
                                    this.reportAuthBugsnagError({
                                        title: 'Delete the Invoice Event When Deleting a Lease.',
                                        errorType: 'Firestore Database',
                                        section: 'Events/Rent',
                                        uid: 'ak0rQkPm6hoMo76WxRp9',
                                        error: error
                                    });
                
                                });

                            });

                        })
                        .then(() => {

                            /*
                            **  Set the prop
                            **  @prop: @here
                            */

                            this.delete_lease_invoice_events_deleted_complete = true;

                        })
                        .catch(error => {

                            /*
                            **  Set the error prop
                            **  @prop: @here
                            */

                            this.delete_lease_error = true;

                            /*
                            **  Send to Bugsnag
                            **  @service: Bugsnag/BugsnagService
                            */
                        
                            this.reportAuthBugsnagError({
                                title: 'Delete the Invoice Event When Deleting a Lease.',
                                errorType: 'Firestore Database',
                                section: 'Events/Rent',
                                uid: 'af2rmeTRfxeC1ap2dRFR',
                                error: error
                            });

                        });

                    });

                }

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Get and Delete the Invoice Events for a Deleted Lease.',
                    errorType: 'Application',
                    section: 'Events/Leases',
                    uid: 'N2MQDtikfGm1Uu6GUy79',
                    error: e
                });

            }

        }

    }

}